module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_6000.00fff764.png";